import { useAuthStore } from '@/stores/authStore'
import { useTranslation } from '@/hooks/use-translation'
import { useShop } from '@/context/shop-context'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { TallyEmbed } from '@/components/tally-embed'

const FALLBACK_EMAIL = 'sales@menupoints.io'

interface EnterpriseContactModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function EnterpriseContactModal({
  open,
  onOpenChange,
}: EnterpriseContactModalProps) {
  const { t } = useTranslation()
  const formId = import.meta.env.VITE_TALLY_ENTERPRISE_FORM_ID as string | undefined
  const user = useAuthStore.getState().auth.user
  const { activeShop } = useShop()
  const organizationId =
    activeShop?.organization_id ?? user?.organization_id ?? ''

  const params: Record<string, string> = {}
  if (organizationId) params['organization_id'] = organizationId
  if (user?.id) params['user_id'] = user.id

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className='max-w-2xl'>
        <DialogHeader>
          <DialogTitle>{t('Enterprise Contact')}</DialogTitle>
        </DialogHeader>
        {formId ? (
          <TallyEmbed
            formId={formId}
            params={params}
            fallbackEmail={FALLBACK_EMAIL}
            testId='tally-iframe'
          />
        ) : (
          <p className='text-sm text-muted-foreground'>
            {t('or contact us at')}{' '}
            <a
              href={`mailto:${FALLBACK_EMAIL}`}
              className='text-primary underline'
            >
              {FALLBACK_EMAIL}
            </a>
          </p>
        )}
      </DialogContent>
    </Dialog>
  )
}
